export const icons = {
  companyResearch: {
    label: "Company Research",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/company_os_icon.svg",
  },
  benchmarks: {
    label: "Benchmarks",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/benchmark_os_icon.svg",
  },
  marketForecasts: {
    label: "Market Forecasts",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/marketforecast_os_icon.svg",
  },
  marketLandscapes: {
    label: "Market Landscapes",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/marketlandscape_os_icon.svg",
  },
  specialReports: {
    label: "Special Reports",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/specialreport_os_icon.svg",
  },
  customerStudies: {
    label: "Customer Studies",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/customerstudy_os_icon.svg",
  },
  ecosystems: {
    label: "Ecosystems",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/ecosystem_os_icon.svg",
  },
  projects: {
    label: "Project",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/project_os_icon.svg",
  },
  pdf: {
    label: "Pdf",
    value:
      "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/pdf_os_icon.svg",
  },
};
